module.exports = __webpack_public_path__ + "img/bkhx.a596826d.png";